// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3kTzZ","error":"Textarea_error__RyjWu","readonly":"Textarea_readonly__35cGI","disabled":"Textarea_disabled__3YVU5"};